<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-col lg="11" sm="8" xl="7">
        <v-card class="elevation-4">
          <v-row>
            <v-col lg="7" class="info d-none d-md-flex align-center justify-center">
              <div class="d-none d-sm-block">
                <div class="d-flex align-center pa-10">
                  <div>
                    <img src="../../assets/images/logo-png.png" height="400" />
                  </div>
                </div>
              </div>
            </v-col>
            <v-col lg="5">
              <div class="pa-7 pa-sm-12">
                <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">Seguimiento Nominal</h2>
                <h6 class="subtitle-1">
                  No tienes una cuenta
                  <a href="https://sir.diresacajamarca.gob.pe:8002/formulario" class>Registrate aqui</a>
                </h6>

                <v-form ref="form" v-model="valid" lazy-validation action="/dashboards/analytical">
                  <v-text-field
                    v-model="form.email"
                    :rules="emailRules"
                    label="Correo"
                    class="mt-4"
                    required
                    outlined
                  ></v-text-field>
                  <v-text-field
                    v-model="form.password"
                    :counter="10"
                    :rules="passwordRules"
                    label="Contraseña"
                    required
                    outlined
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                  ></v-text-field>

                  <v-btn
                    :disabled="!valid"
                    color="info"
                    block
                    class="mr-4"
                    submit
                    @click="login"
                  >Sign In</v-btn>
                </v-form>
                <div class="text-center mt-6">
                  <div class="d-block d-sm-flex align-center mb-4 mb-sm-0">
                    <div class="ml-auto">
                      <a href="https://sir.diresacajamarca.gob.pe:8002/login/reset" class="link">¿Olvidaste tu contraseña?</a>
                    </div>
                    <br>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import {  setToken } from '@/utils/auth'
import { login } from "../../apis/User"

export default {
  name: "BoxedLogin",

  data: () => ({
    valid: true,
    form: {
        email: "",
        password: ""
      },
    show1: false,
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length <= 10) || "Password must be less than 10 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    checkbox: false
  }),
  computed: {},
  methods: {
      ...mapActions({
          signIn:'auth/login'
      }),
    async login() {
      this.$refs.form.validate();
      if (this.$refs.form.validate(true)) {
          login(this.form).then((data)=>{
            setToken(data.access_token)
            this.signIn()
          }).catch(({response:{data}})=>{
              alert(data.message)
          }).finally(()=>{
              this.processing = false
          })
      }
    }
  }
};
</script>
